import { useEffect, useState } from 'react'

import addDocument from '@/assets/svgs/newSvgs/addDocument.svg'
import addFiles from '@/assets/svgs/newSvgs/addFiles.svg'
import blankCanvas from '@/assets/svgs/newSvgs/blankCanvas.svg'
import connectionLost from '@/assets/svgs/newSvgs/connectionLost.svg'
import empty from '@/assets/svgs/newSvgs/empty.svg'
import fileAnalysis from '@/assets/svgs/newSvgs/fileAnalysis.svg'
import fileSearch from '@/assets/svgs/newSvgs/fileSearch.svg'
import fileSearching from '@/assets/svgs/newSvgs/fileSearching.svg'
import maintenance from '@/assets/svgs/newSvgs/maintenance.svg'
import noData from '@/assets/svgs/newSvgs/noData.svg'
import pageNotFound from '@/assets/svgs/newSvgs/pageNotFound.svg'
import photos from '@/assets/svgs/newSvgs/photos.svg'
import working from '@/assets/svgs/newSvgs/working.svg'

// Lista de nombres de archivos SVG en la carpeta src/assets/svgs
const svgFiles = {
  addDocument,
  addFiles,
  blankCanvas,
  connectionLost,
  empty,
  fileAnalysis,
  fileSearch,
  fileSearching,
  maintenance,
  noData,
  pageNotFound,
  photos,
  working,
} as const

type SvgType = keyof typeof svgFiles
interface Empty {
  title?: string
  subTitle?: string
  size?: 'xs' | 's' | 'm' | 'l'
  svgType?: SvgType
}

const EmptyList = ({ title, subTitle, svgType }: Empty) => {
  const [svg, setSvg] = useState<string | null>(null)
  const [loaded, setLoaded] = useState<boolean>(false)

  useEffect(() => {
    // Seleccionar el archivo SVG
    const selectedSvg = svgType ? svgFiles[svgType] : svgFiles.noData
    setSvg(selectedSvg)
    setTimeout(() => {
      setLoaded(true) // Indicar que la carga ha comenzado
    }, 100)
  }, [svgType])

  if (!svg) {
    return <div>Cargando...</div>
  }

  return (
    <div
      className={`flex h-auto min-h-0 flex-1 flex-col items-center justify-center ${
        loaded ? 'opacity-100 transition-opacity duration-200' : 'opacity-0'
      } `}
    >
      <div className="flex min-h-0 max-w-24 flex-shrink items-center justify-center">
        <img
          alt="No hay datos svg"
          className="max-h-24 object-scale-down"
          src={svg}
        />
      </div>

      <p className="text-customBlue-500 py-2 text-sm font-thin">
        {title ?? 'No hay elementos que mostrar'}
      </p>
      {
        <p className="text-customBlue py-2 text-sm font-thin">
          {subTitle ?? ''}
        </p>
      }
    </div>
  )
}

export default EmptyList
